import { render, staticRenderFns } from "./MenuItemBoxCourse.vue?vue&type=template&id=0a14ff27&"
import script from "./MenuItemBoxCourse.vue?vue&type=script&lang=js&"
export * from "./MenuItemBoxCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports